// Keyed by the raw API value. Display only: `FinanceManger` is misspelled in the API
// and must never be changed or sent back.
export const teammateAppAccessLevelLabelIds: Record<string, TranslationId> = {
  Owner: 'Owner',
  StoreOwner: 'Sales_channel_owner',
  PropertyOwner: 'Property_owner',
  ManagedOwner: 'Managed_owner',
  Integrator: 'Integrator',
  PropertyManager: 'Property_manager',
  StoreManager: 'Sales_channel_manager',
  StoreStaff: 'Sales_channel_staff',
  StaffMember: 'Staff_member',
  StoreReadOnlyAccess: 'Sales_channel_readonly_access',
  FinanceManger: 'Finance_manager',
};

/** Returns the translation id for a level, or undefined for unknown or future values. */
export const getTeammateAppAccessLevelLabelId = (level: string): TranslationId | undefined =>
  Object.prototype.hasOwnProperty.call(teammateAppAccessLevelLabelIds, level)
    ? teammateAppAccessLevelLabelIds[level]
    : undefined;
